<template>
  <div class="main">
    <Header 
      :show="true"
      title="修改物料信息"
      left="prepage" 
      right="" 
      :click-left="handleClickLeft" 
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c" background="#FFFBE8" 
      text="注意：更新物料信息不支持修改名称"
      />
      <van-form 
        ref="update"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.name"
        label="名称"
        placeholder="请输入物料名称"
        required
        disabled
        :rules="[{ validator: validName, message: '' }]"
      />
      <van-field
        clickable
        name="picker"
        :value="listQuery.type"
        label="类别"
        placeholder="点击选择类别"
        required
        @click="type.show = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="type.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="type.columns"
          @confirm="handleMaterialTypeSelect"
          @cancel="type.show = false"
        />
      </van-popup>
      <van-field
        v-model.trim="listQuery.standard"
        label="规格"
        placeholder="请输入物料规格"
        required
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.unit"
        label="单位"
        placeholder="请输入物料单位"
        required
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model.trim="listQuery.remark"
        rows="2"
        autosize
        label="说明"
        type="textarea"
        maxlength="100"
        placeholder="请输入物料说明"
        show-word-limit
        :rules="[{ required: true, message: '' }]"
        />
        <div style="margin: .6rem 1rem;" v-if="checkPermission([203])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { updateOne } from '@/api/material.js'

  export default {
    name: "ServiceSystemMaterialUpdate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        isLoading: false,
        loading: false,
        listQuery: {
          serial: '',
          name: '',
          type: '骨料',
          standard: '',
          unit: '',
          remark: ''
        },
        type: {
          show: false,
          columns: ['骨料', '粉料', '其他']
        }
      }
    },
    computed: {

    },
    watch: {
      
    },
    beforeCreate() {
      
    },
    created() {
      
    },
    beforeMount() {
      
    },
    mounted() {
      this.listQuery = this.$route.query
    },
    beforeUpdate() {
      
    },
    updated() {
      
    },
    beforeDestroy() {
      
    },
    destroyed() {
      
    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.update.submit()
      },
      submit() {
        Dialog.confirm({
          title: '确认更新物料？',
          message: '物料名称：' + this.listQuery.name
        }).then(() => {
          this.loading = true
          const data = {
            id: this.listQuery.serial,
            name: this.listQuery.name,
            type: this.type.columns.indexOf(this.listQuery.type)+1,
            standard: this.listQuery.standard,
            unit: this.listQuery.unit,
            remark: this.listQuery.remark
          }
          updateOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '更新物料', data.message)) {
              this.$router.push({ path:'/service/system/material', query: {} })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '更新物料', '取消')
        })
      },
      handleMaterialTypeSelect(value) {
        this.listQuery.type = value
        this.type.show = false
      },
      validName(value) {
        return new Promise((resolve) => {
          const result = isChinese(value, 2, 20)
          if (result === true) {
            resolve(true)
          } else {
            showPhoneAlarm(true, 'toast', null, 2000, null, result, null)
            resolve(false)
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-field__control:read-only {
    color: #999;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8; 
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex; 
    // justify-content: center; 
    // align-items: center;
  }
</style>
